import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from 'react-router-dom';
import * as moment from 'moment';
import { TableWrapper, Heading, NameSection } from './chatBlockStyled'
import styles from './chatBlock.module.scss'
import xIcon from 'web/assets/images/XIcon.png';
import RefreshIcon from 'web/assets/svg/RefreshIcon';
import AlertModal from 'web/components/AlertModal';
import AdminChatIcon from 'web/assets/images/AdminChatIcon.png';
import ViewTerms from 'web/assets/images/view-terms.png';
import { fetchAllOrderChatList, fetchMessagesByOrder } from 'redux/actions/admin';

function OrderChatList() {
  const dispatch = useDispatch();
  let history = useHistory()
  const adminRoles = useSelector(state => state.admin.adminRoles)
  const [loader, setLoader] = useState(false)
  const [displayDiv, setDisplayDiv] = useState('nameList')
  const [chatOrdersList, setChatOrdersList] = useState()
  const [chatMessagesByOrder, setChatMesagesByOrder] = useState()
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const toggleModal = () => setModal(!modal)

  useEffect(() => {
    let userRole = localStorage.getItem('accountType')
    let appUserRolesList = ['Both', 'Buyer', 'Seller']
    if (userRole !== 'Admin') {
      if (appUserRolesList.includes(userRole)) history.push('/dashboard')
      else history.push('/sign-in')
      window.location.reload();
    }
    fetchMessageList();
  }, [])

  const fetchMessageList = async () => {
    setChatOrdersList()
    setLoader(true)
    let response = '';
    let token = localStorage.getItem('token')
    response = await dispatch(fetchAllOrderChatList(token));
    setLoader(false)
    if (response?.adminChatResponseList) {
      const sortedList = response?.adminChatResponseList?.sort((a, b) => moment(b.lastUpdated).diff(moment(a.lastUpdated)));
      setChatOrdersList(sortedList)
    } else {
      if (response?.statusCode === 401) {
        localStorage.removeItem('token')
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response.data?.message || response.message || 'Something went wrong, please try after sometime.')
        setModal(!modal)
      }
    }
  }

  const fetchOrderChats = async (data) => {
    let response = '';
    let token = localStorage.getItem('token')
    response = await dispatch(fetchMessagesByOrder(token, data.orderId));
    if (response?.chatHistory?.contents?.length) {
      setChatMesagesByOrder(response?.chatHistory)
      setDisplayDiv('chatList')
    } else {
      if (response?.statusCode === 401) {
        localStorage.removeItem('token')
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response.data?.message || response.message || 'Something went wrong, please try after sometime.')
        setModal(!modal)
      }
    }
  }

  const getChatMessageHeader = () => {
    return (
      <>
        {chatMessagesByOrder?.orderId}
        <span style={{ fontSize: '16px', marginLeft: '5px' }}>{`(Buyer: ${chatMessagesByOrder.buyerLocationName}, Seller: ${chatMessagesByOrder.sellerLocationName})`}</span>
      </>
    )
  }

  const getLocalTime = (utcTime, format) => {
    const utcMoment = moment.utc(utcTime);
    const localTime = utcMoment.local();
    return localTime.format(format);
  }

  return (
    <>
      {(adminRoles && (adminRoles.includes('SUPER_ADMIN') || adminRoles.includes('ORDER_CHAT') || adminRoles.includes('CHAT'))) ?
        <>
          <TableWrapper style={{ height: (displayDiv === 'nameList') ? '99%' : '91%' }}>
            <Heading>
              <div className={styles.listingDiv}>
                <img src={AdminChatIcon} alt="AdminChatIcon" />
                <h3>{displayDiv === 'nameList' ? 'Orders List' : getChatMessageHeader()}</h3>
              </div>
              {displayDiv === 'chatList' &&
                <img className={styles.xIcon} src={xIcon} alt="X-Icon" onClick={() => setDisplayDiv('nameList')} />
              }
              {displayDiv === 'nameList' &&
                <div onClick={fetchMessageList} style={{ cursor: 'pointer' }}><RefreshIcon /></div>
              }
            </Heading>

            {displayDiv === 'nameList' &&
              <div style={{ height: '100%' }}>
                <div style={{ height: '85%', overflow: 'auto' }}>
                  <NameSection >
                    <div><span>Order ID</span></div>
                    <div><span>Buyer Company Name</span></div>
                    <div><span>Seller Company Name</span></div>
                    <div><span>Chat Last Updated At</span></div>
                  </NameSection>
                  <hr style={{ margin: '-5px 48px 17px 30px' }} />
                  {chatOrdersList?.map((data, index) => {
                    return (
                      <>
                        <NameSection>
                          <div>
                            <h6>{data.orderId}</h6>
                          </div>
                          <div>
                            <h6>{data.buyerLocationName}</h6>
                          </div>
                          <div>
                            <h6>{data.sellerLocationName}</h6>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <h6>{getLocalTime(data.lastUpdated, 'MM/DD/YYYY, HH:mm')}</h6>
                            <img title='View' src={ViewTerms} className="ViewTerms" alt="view-icon" onClick={() => fetchOrderChats(data)} />
                          </div>
                        </NameSection>
                        <hr style={{ margin: '0px 48px 0px 30px' }} />
                      </>
                    )
                  })}
                  {((loader && !chatOrdersList) || (chatOrdersList && chatOrdersList?.length === 0)) &&
                    <p style={{ textAlign: 'center', paddingTop: '90px' }}>{(loader && !chatOrdersList) ? 'Loading...' :
                      (chatOrdersList && chatOrdersList?.length === 0) ? 'No records found.' : ''}</p>
                  }
                </div>
              </div>
            }

            {displayDiv === 'chatList' &&
              <div style={{ height: '88%' }}>
                <div style={{ height: 'calc(100vh - 220px)', overflow: 'auto', display: 'flex', flexDirection: 'column-reverse', paddingBottom: '25px' }}>
                  <div>
                    {chatMessagesByOrder?.contents?.map(data => {
                      return (
                        <div className={styles.chatPanel}>
                          <div class={data.senderType === 'BUYER' ? "col-md-9" : "col-md-9 offset-md-3"}>
                            <div className={data.senderType === 'BUYER' ? styles.chatBoxLeft : styles.chatBoxRight}>
                              <div className={data.senderType === 'BUYER' ? 'sender-initial sender-initial-buyer' : 'sender-initial sender-initial-seller'}>{data.senderType === 'BUYER' ? 'B' : 'S'}</div>
                              <div style={{ maxWidth: '85%', wordWrap: 'break-word' }}>
                                <p className={data.senderType === 'BUYER' ? `${styles.chatBubbleL} ${styles.chatBubbleLLeft}` : `${styles.chatBubbleR} ${styles.chatBubbleRRight}`}>
                                  {data.msg}
                                </p>
                                <span className={data.senderType === 'BUYER' ? styles.dateCssLeft : styles.dateCssRight}>{getLocalTime(data.date, 'MMM Do, YYYY, HH:mm')}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            }
          </TableWrapper>
          {displayDiv === 'chatList' &&
            <button className={styles.backButton} onClick={() => setDisplayDiv('nameList')}>Back</button>
          }
          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title=''
            content={modalContent}
          />
        </>
        :
        <p>You are not authorized to view this page.</p>
      }
    </>
  );
}

export default OrderChatList;